export default __webpack_public_path__ + "static/imperfective-time-8b38f057727ce9a3c9f73b402c0d51c2.svg";